import React, { useMemo } from 'react';
import { useListAdminUserRolesQuery } from '../../../API/administration/AdminUsersAPI';
import { ErrorMessageTW } from '../../../tailwindComponents/errorMessage/ErrorMessageTW';
import { TextFieldTW } from '../../../tailwindComponents/textInputTW/TextFieldTW';
import { SelectOption } from '../../../tailwindComponents/selectTW/interfaces';
import { LoadingSpinnerTW } from '../../../tailwindComponents/loadingSpinnerTW/LoadingSpinnerTW';
import { SelectFieldTW } from '../../../tailwindComponents/selectTW/SelectFieldTW';

export const EditAdminUserFormFields: React.FC = () => {
  const { data: adminUserRoles = [], isFetching, error } = useListAdminUserRolesQuery(undefined);

  const roleOptions: SelectOption[] = useMemo(
    () =>
      adminUserRoles.map(({ label, id }) => ({
        label,
        value: id,
      })),
    [adminUserRoles]
  );

  return (
    <>
      <ErrorMessageTW rtkError={error} />
      <TextFieldTW name={'fullName'} labelText={'Full Name'} isRequired />
      <TextFieldTW name={'email'} labelText={'email'} isRequired placeholder={'name@zillowgroup.com'} />
      <LoadingSpinnerTW isLoading={isFetching}>
        <SelectFieldTW name={'roles'} options={roleOptions} isMultiple labelText={'Roles'} />
      </LoadingSpinnerTW>
    </>
  );
};
